/* eslint-disable no-case-declarations */
import {
    UPDATE_PROJECT_TITLE,
    TOGGLE_NAVIGATION,
    HIDE_TOAST,
    SELECTING_SECTION,
    RECEIVED_CATEGORIES,
    SELECTING_CATEGORY,
    RECEIVED_PRODUCTS,
    SELECT_PRODUCT,
    SELECT_NAMED_PRODUCT,
    SELECTING_PRODUCT,
    RECEIVED_PRODUCT_DETAILS,
    EDIT_PRODUCT,
    REMOVE_PRODUCT,
    BUYING,
    BOUGHT,
    START,
    RESET,
    SET_SKIN_TONE,
    SET_ACTIVE_FILTER,
    SET_TORSO_TEXT,
    SET_TORSO_OVERLAY,
    SET_AFTER_CURSOR,
    SET_CURRENT_FILTERS,
    SET_LOADING_TRUE,
    SET_CONFIG,
    SET_CURRENT_BUILD_INDEX,
    REMOVE_BUILD,
    REMOVE_SELECTED_BUILD,
    ADD_BUILD,
    ERROR_BUYING,
    RESET_ERROR_BUYING,
    PROJECT_ADDED_TO_CART,
    RESET_ADDED_PROJECTS,
} from './actions';
import { LOAD } from 'redux-storage';

import SelectedProduct from './entities/SelectedProduct';

/**
 * Redux reducers
 *
 * @author John Noel <john.noel@joipolloi.com>
 * @package Minifigs
 */

const buildTemplate = {
    projectTitle: null,
    selected: {
        hatsAndHair: null,
        heads: null,
        bodies: null,
        legs: null,
        display: null,
        accessory1: null,
        accessory2: null,
        accessory3: null,
        accessory4: null,
    },
    skintone: null,
    torsoText: {
        backText: '',
        frontText: '',
    },
    torsoOverlays: null,
};

export const initialState = {
    // the selected product for each section
    // if a product has been selected it will be a SelectedProduct object
    loaded: false,
    currentBuildIndex: 0,
    builds: [{ ...buildTemplate }],
    navigation: {
        // the section that's currently been selected
        selected: null,
    },
    browser: {
        // the name of the currently viewed section (e.g. 'Hats and Hair')
        name: null,
        // the selected category (e.g. 'Brown hair')
        selectedCategory: null,
        // the list of categories for the section (exclusive with products)
        categories: [],
        // the selected product only if the product needs customising
        selectedProduct: null,
        // the list of products for the section (exclusive with categories)
        products: [],
    },
    breadcrumbs: {
        section: null,
        category: null,
        product: null,
    },
    loading: false,
    buying: false,
    finished: false,
    showNavigation: false,
    showToast: false,
    errorOnBuy: false,
    errorMessage: null,
    sections: [],
    filters: [],
    addedProjects: [],
};

export default function root(state = initialState, action) {
    const buildIndex = action?.payload?.buildIndex;
    switch (action.type) {
        case '@@redux/INIT':
            return {
                ...initialState,
                ...state,
                loaded: false,
            };

        case LOAD:
            return {
                ...state,
                ...action.payload,
                loaded: true,
            };

        case SET_CONFIG:
            return {
                ...state,
                ...action.payload,
            };

        case UPDATE_PROJECT_TITLE:
            const { title } = action.payload;
            if (buildIndex !== undefined && buildIndex >= 0 && buildIndex < state.builds.length) {
                const builds = state.builds.map((build) => {
                    return { ...build };
                });
                const newTitle = title.split('-')[0];
                const selected = { ...builds[buildIndex].selected };
                Object.keys(selected).forEach((selectedKey) => {
                    if (selected[selectedKey]?.productFormJsonValues?.properties?.projectTitle) {
                        selected[selectedKey].productFormJsonValues.properties.projectTitle = newTitle;
                    }
                });
                builds[buildIndex].projectTitle = newTitle;

                // console.log({title});
                return {
                    ...state,
                    builds: builds.map((build) => {
                        return { ...build };
                    }),
                };
            }
            return state;
        case TOGGLE_NAVIGATION:
            return {
                ...state,
                showNavigation: !state.showNavigation,
            };

        case HIDE_TOAST:
            return {
                ...state,
                showToast: false,
            };
        //
        // Select a section, receive categories
        //
        case SELECTING_SECTION:
            return {
                ...state,
                navigation: {
                    selected: action.payload,
                },
                browser: {
                    ...state.browser,
                    categories: [],
                    products: [],
                },
                breadcrumbs: {
                    section: action.payload,
                    category: null,
                    product: null,
                },
                loading: true,
            };
        case RECEIVED_CATEGORIES:
            return {
                ...state,
                browser: {
                    ...state.browser,
                    selectedCategory: null,
                    selectedProduct: null,
                    categories: action.payload,
                },
                loading: false,
                showNavigation: false,
            };
        //
        // Select a category, receive products
        //
        case SELECTING_CATEGORY:
            return {
                ...state,
                browser: {
                    ...state.browser,
                    selectedCategory: action.payload,
                    selectedProduct: null,
                },
                breadcrumbs: {
                    ...state.breadcrumbs,
                    category: action.payload,
                    product: null,
                },
                loading: true,
            };
        case RECEIVED_PRODUCTS:
            return {
                ...state,
                browser: {
                    ...state.browser,
                    products: action.payload,
                },
                loading: false,
            };

        //
        // Selecting a product or customising it
        //
        case SELECTING_PRODUCT:
            return {
                ...state,
                browser: {
                    ...state.browser,
                    selectedProduct: action.payload,
                },
                breadcrumbs: {
                    ...state.breadcrumbs,
                    product: action.payload,
                },
                loading: true,
            };
        case RECEIVED_PRODUCT_DETAILS:
            return {
                ...state,
                browser: {
                    ...state.browser,
                    selectedProduct: {
                        ...state.browser.selectedProduct,
                        variations: action.payload.variations,
                        product_attribute: action.payload.product_attribute,
                        attribute_terms: action.payload.attributeTerms,
                        productFormJsonValues: action.payload.productFormJsonValues,
                    },
                },
                loading: false,
            };
        case SELECT_PRODUCT:
            const { product, attributes, addons, product_attribute, attributeTerms, productFormJsonValues } =
                action.payload;
            if (buildIndex !== undefined && buildIndex >= 0 && buildIndex < state.builds.length) {
                const builds = state.builds.map((build) => {
                    return { ...build };
                });
                const currentBuild = builds[state.currentBuildIndex];
                builds[state.currentBuildIndex].selected = {
                    ...currentBuild.selected,
                    [state.navigation.selected]: new SelectedProduct(
                        product,
                        state.browser.selectedCategory,
                        attributes,
                        addons,
                        product_attribute,
                        attributeTerms,
                        productFormJsonValues
                    ).toJSON(),
                };
                return {
                    ...state,
                    builds: builds.map((build) => {
                        return { ...build };
                    }),
                    showToast: true,
                };
            }
            return state;
        case SELECT_NAMED_PRODUCT:
            const catName = action.payload.product_category.id ?? action.payload.product_category;
            if (buildIndex !== undefined && buildIndex >= 0 && buildIndex < state.builds.length) {
                const builds = state.builds.map((build) => {
                    return { ...build };
                });
                const currentBuild = builds[state.currentBuildIndex];
                builds[state.currentBuildIndex].selected = {
                    ...currentBuild.selected,
                    [catName]: new SelectedProduct(
                        action.payload.product,
                        catName ? action.payload.product_category : state.browser.selectedCategory,
                        action.payload.attributes,
                        action.payload.addons,
                        action.payload.product_attribute,
                        action.payload.attributeTerms,
                        action.payload.productFormJsonValues
                    ).toJSON(),
                };

                return {
                    ...state,
                    builds: builds.map((build) => {
                        return { ...build };
                    }),
                    showToast: true,
                };
            }
            return state;
        //
        // Edit product
        //
        case EDIT_PRODUCT:
            const currentBuildCategory =
                state.builds[state.currentBuildIndex].selected[action.payload.sectionId].category;
            const currentBuildProduct =
                state.builds[state.currentBuildIndex].selected[action.payload.sectionId].product;
            // const buildIndex = state?.currentBuildIndex;
            if (
                state.currentBuildIndex !== undefined &&
                state.currentBuildIndex >= 0 &&
                state.currentBuildIndex < state.builds.length
            ) {
                return {
                    ...state,
                    browser: {
                        ...state.browser,
                        selectedCategory: currentBuildCategory,
                        selectedProduct: currentBuildProduct,
                    },
                    navigation: {
                        ...state.navigation,
                        selected: action.payload.sectionId,
                    },
                    breadcrumbs: {
                        section: action.payload.sectionId,
                        category: currentBuildCategory,
                        product: currentBuildProduct,
                    },
                };
            }
            return state;
        //
        // Remove product
        //
        case REMOVE_PRODUCT:
            const { sectionId } = action.payload;
            if (buildIndex !== undefined && buildIndex >= 0 && buildIndex < state.builds.length) {
                const builds = state.builds.map((build) => {
                    return { ...build };
                });
                const currentBuild = builds[state.currentBuildIndex];
                builds[state.currentBuildIndex].selected = {
                    ...currentBuild.selected,
                    [sectionId]: null,
                };
                return {
                    ...state,
                    builds: builds.map((build) => {
                        return { ...build };
                    }),
                };
            }
            return state;
        //
        // Buy
        //
        case BUYING:
            return {
                ...state,
                loading: true,
                buying: true,
            };
        case ERROR_BUYING:
            const { errorMessage } = action.payload;
            return {
                ...state,
                loading: false,
                buying: false,
                finished: false,
                errorOnBuy: true,
                errorMessage,
            };
        case RESET_ERROR_BUYING:
            return{
                ...state,
                errorOnBuy: false,
                errorMessage: null,
                finished: false,
            }
        case BOUGHT:
            // todo show finish screen
            return {
                ...state,
                loading: false,
                buying: false,
                finished: true,
            };
        //
        // Start screen
        //
        case START:
            return {
                ...state,
                navigation: {
                    selected: null,
                },
                showNavigation: false,
            };
        //
        // Reset
        //
        case RESET:
            const currentBuilds = state.builds.map((build) => {
                return { ...build };
            });
            return {
                ...initialState,
                builds: [...currentBuilds],
            };
        case SET_SKIN_TONE:
            const { skintone } = action.payload;
            if (buildIndex !== undefined && buildIndex >= 0 && buildIndex < state.builds.length) {
                const builds = state.builds.map((build) => {
                    return { ...build };
                });
                builds[state.currentBuildIndex].skintone = skintone;
                return {
                    ...state,
                    builds: builds.map((build) => {
                        return { ...build };
                    }),
                };
            }
            return state;
        case SET_ACTIVE_FILTER:
            return {
                ...state,
                activeFilter: action.payload,
            };
        case SET_TORSO_TEXT: {
            const { torsoText } = action.payload;
            if (buildIndex !== undefined && buildIndex >= 0 && buildIndex < state.builds.length) {
                const builds = state.builds.map((build) => {
                    return { ...build };
                });
                builds[state.currentBuildIndex].torsoText = {
                    backText: torsoText.backText !== undefined ? torsoText.backText : state.torsoText.backText,
                    frontText: torsoText.frontText !== undefined ? torsoText.frontText : state.torsoText.frontText,
                };
                return {
                    ...state,
                    builds: builds.map((build) => {
                        return { ...build };
                    }),
                };
            }
            return state;
        }
        case SET_TORSO_OVERLAY: {
            const { torsoOverlays } = action.payload;
            if (buildIndex !== undefined && buildIndex >= 0 && buildIndex < state.builds.length) {
                const builds = state.builds.map((build) => {
                    return { ...build };
                });
                builds[state.currentBuildIndex].torsoOverlays = torsoOverlays;
                return {
                    ...state,
                    builds: builds.map((build) => {
                        return { ...build };
                    }),
                };
            }
            return state;
        }
        case SET_AFTER_CURSOR:
            return {
                ...state,
                paginationInfo: {
                    afterCursor: action.payload.afterCursor,
                    hasNextPage: action.payload.hasNextPage,
                },
            };
        case SET_CURRENT_FILTERS: {
            return {
                ...state,
                currentFilters: action.payload,
            };
        }
        case SET_LOADING_TRUE: {
            return {
                ...state,
                loading: true,
            };
        }
        case SET_CURRENT_BUILD_INDEX: {
            const { buildIndex } = action.payload;
            if (buildIndex < state.builds.length) {
                return {
                    ...state,
                    currentBuildIndex: buildIndex,
                };
            }
            return state;
        }
        case REMOVE_BUILD: {
            const { buildIndex } = action.payload;
            if (buildIndex < state.builds.length) {
                const newBuilds = [...state.builds];
                newBuilds.splice(buildIndex, 1);
                if (newBuilds.length === 0) {
                    newBuilds.push({ ...buildTemplate }); // We always have one build in place, even if it's empty
                }
                return {
                    ...state,
                    currentBuildIndex:
                        buildIndex === state.currentBuildIndex || state.currentBuildIndex >= newBuilds.length
                            ? 0
                            : state.currentBuildIndex, // If the build we were selecting is the one we're deleting we set the current to 0 which we know exists
                    builds: [...newBuilds],
                    navigation: {
                        selected: null,
                    },
                };
            }
            return state;
        }
        case REMOVE_SELECTED_BUILD: {
            const { selectedBuild } = action.payload;
            const newBuilds = state.builds
                .filter((build) => build.projectTitle !== selectedBuild.projectTitle)
                .map((build) => {
                    return { ...build };
                });
            if (newBuilds.length === 0) {
                newBuilds.push({ ...buildTemplate }); // We always have one build in place, even if it's empty
            }
            return {
                ...state,
                currentBuildIndex:
                    buildIndex === state.currentBuildIndex || state.currentBuildIndex >= newBuilds.length
                        ? 0
                        : state.currentBuildIndex, // If the build we were selecting is the one we're deleting we set the current to 0 which we know exists
                builds: [...newBuilds],
                navigation: {
                    selected: null,
                },
            };
        }
        case PROJECT_ADDED_TO_CART: {
            const newAddedProjects = [...state.addedProjects, action.payload.projectTitle];
            return {
                ...state,
                addedProjects: newAddedProjects,
            };
        }
        case RESET_ADDED_PROJECTS: {
            return {
                ...state,
                addedProjects: [],
            };
        }
        case ADD_BUILD: {
            const initialData = action.payload ?? {};
            let newBuilds = [...state.builds];
            if (state.builds.length === 1 && !state.builds[0].projectTitle) {
                newBuilds = [];
            }

            newBuilds.push({ ...buildTemplate, ...initialData });
            return {
                ...state,
                currentBuildIndex: newBuilds.length - 1,
                builds: [...newBuilds],
                navigation: {
                    selected: null,
                },
            };
        }
    }

    return state;
}
